import { Dialog } from 'primereact/dialog';
import AuftragDetailComponent from '../AuftragDetailComponent/AuftragDetailComponent';

interface ComponentProps {
  close: () => void;
  dialogVisible: boolean;
  uid_auftrag: string | undefined;
}

/**
 * @author noone
 */
const DialogAuftragComponent: React.FC<ComponentProps> = (props) => {

  return (
    <Dialog
      visible={props.dialogVisible}
      onHide={() => props.close()}
      header={"Dialog Auftrag"}
      modal
      style={{ width: '100vw', height: '50vh', position: 'fixed', bottom: 0, left: 0, top: 'auto' }}
    >
      <AuftragDetailComponent uid={props.uid_auftrag} backbuttonVisible={false} backbuttonClose={false} />
    </Dialog>
  );

}

export default DialogAuftragComponent;